/*
 * @创建文件时间: 2020-02-16 14:37:13
 * @Auther: lfq
 * @最后修改人: lfq
 * @最后修改时间: 2020-02-19 11:12:45
 * @联系Qq:1638245306
 * @文件介绍: 交通量
 */
export default [{
    path: 'trafficVolumeParameter',
    name: 'trafficVolumeParameter',
    meta: {
        title: '车型库',
        auth: true
    },
    component: () =>
        import ('@/views/trafficData/trafficVolumeParameter')
}, {
    path: 'mqiModelLibrary',
    name: 'mqiModelLibrary',
    meta: {
        title: '代表车型库',
        auth: true
    },
    component: () =>
        import ('@/views/trafficData/mqiModelLibrary')
}, {
    path: 'mqiConversionFactor',
    name: 'mqiConversionFactor',
    meta: {
        title: '车型转换系数表',
        auth: true
    },
    component: () =>
        import ('@/views/trafficData/mqiConversionFactor')
}, {
    path: 'mqiTrafficManagement',
    name: 'mqiTrafficManagement',
    meta: {
        title: '交通量管理',
        auth: true
    },
    component: () =>
        import ('@/views/trafficData/mqiTrafficManagement')
}, {
    path: 'mqiTrafficData',
    name: 'mqiTrafficData',
    meta: {
        title: '交通量数据',
        auth: true
    },
    component: () =>
        import ('@/views/trafficData/mqiTrafficData')
}, {
    path: 'mqiTrafficReport',
    name: 'mqiTrafficReport',
    meta: {
        title: '交通量报表',
        auth: true
    },
    component: () =>
        import ('@/views/trafficData/mqiTrafficReport')
},{
        path: 'mqiAxleLoad',
        name: 'mqiAxleLoad',
        meta: {
            title: '年累计当量轴载',
            auth: true
        },
        component: () =>
            import ('@/views/trafficData/mqiAxleLoad')
    }]
